import {routes as admin} from '../modules/admin' 

import {router as login} from '../modules/login'
import {routes as company} from '../modules/company'

 
export default [    
    ...login, 
    ...admin, 
    ...company, 
     
];